export const HOURS_IN_DAY = 24;
export const MINUTES_IN_HOUR = 60;
export const SECONDS_IN_MINUTE = 60;
export const MILLISECONDS_IN_SECOND = 1000;
export const MILLISECONDS_IN_MINUTE =
  MILLISECONDS_IN_SECOND * SECONDS_IN_MINUTE;
export const MILLISECONDS_IN_HOUR =
  MILLISECONDS_IN_SECOND * SECONDS_IN_MINUTE * MINUTES_IN_HOUR;
export const MILLISECONDS_IN_DAY =
  MILLISECONDS_IN_SECOND * SECONDS_IN_MINUTE * MINUTES_IN_HOUR * HOURS_IN_DAY;

export const DUE_THRESHOLD = 72;

// 2 minute cause:
// business requirements says that you need to request continue editing each 2 minutes
export const REACQUIRE_EDIT_LOCK_THRESHOLD_IN_MINUTES = 2;

export const END_OF_DAY_TIME = "23:59:59";
export const DATE_TIME_INDICATOR = "T";

// This time zone is used for testing that times are translated into the user's time zone. This
// particular time zone was picked because it does not observe Daylight Savings Time and thus won't
// have its expectations change when the DST crossover happens.
export const TIMEZONE_MINUS_7_WITHOUT_DST = "America/Phoenix";

// When creating new comments or comment threads, occasionally the server gives us back a
// createdDate that is in the future by a few ms due to clock drift. CKEditor's date formatter does
// not handle dates in the future, and so shows an incorrect format in that case. Subtracting this
// allows for compensating for it on the initial load to ensure that the date is always in the past.
export const CLOCK_DRIFT_OFFSET = 300;
